import React, { FC, useContext } from 'react';

import { ConditionalRendering } from '@components/common/conditional-rendering';
import ErrorMessage from '@components/common/form/errorMessage';
import { NUMBER } from '@constants/common/number';
import DatePicker from '@lib/inputs/react-datepicker';
import { convertLocalToServerTimestamp, DATE_FORMAT } from '@utils/dates/dateMethods';
import { changeFieldValue, setCustomError } from '../common/enrollmentUtils';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';
import { EnrollmentContext } from '../context/MemberMyEnrollmentProvider';
import { environmentSelector, useAppSelector } from '../../utils';

const EnrollmentStartDateField: FC = () => {
    const { selectedEnrollment } = useContext(EnrollmentContext);
    const {
        watch,
        formState: { errors },
        setValue,
        clearErrors,
        setError,
    } = useContext(AddOrChangeTxnFormContext);
    const values = watch();
    const { localDates } = useAppSelector(environmentSelector) || {};
    const timezoneOffsetMs = Number(localDates?.timezoneOffsetMs) || 0;
    const dstSavingsMs = Number(localDates?.dstSavingsMs) || 0;

    const onChangBenefitEffectiveDate = (field: string, date: Date | null) => {
        clearErrors(field);
        const formatedDate = date ? convertLocalToServerTimestamp(date, timezoneOffsetMs, dstSavingsMs, DATE_FORMAT) : '';
        setValue(field, formatedDate, { shouldDirty: true, shouldValidate: true });
        if (!date) {
            setCustomError(
                setError,
                field,
                'error.member.enrollment_list.premiumhistory.enrollee.pleaseEnter.benefitStartDate',
                'wrongDate',
            );
            return;
        } else if (
            formatedDate.substring(NUMBER.SIX, NUMBER.TEN) !==
            selectedEnrollment.enrollmentBenefitEffectiveStartDateUI.substring(NUMBER.SIX, NUMBER.TEN)
        ) {
            setCustomError(setError, field, 'error.member.enrollment_list.termEnrollee.validCoverageYear', 'wrongDate');
        } else {
            const enrolleeDataDtoList = values.enrolleeDataDtoList.map(enrollee => {
                return { ...enrollee, enrolleeEffectiveStartDateUI: formatedDate };
            });
            changeFieldValue(setValue, 'enrolleeDataDtoList', enrolleeDataDtoList);
        }
    };

    return (
        <>
            <DatePicker
                labelText="member.enrollment_list.premiumhistory.enrollee.enrollmentStartDate"
                datePickerClass="gi-input date-picker"
                isRequired
                id="enrollmentStartDate"
                type="text"
                pattern={DATE_FORMAT}
                value={
                    values?.enrollmentBenefitEffectiveStartDateUI
                        ? new Date(values.enrollmentBenefitEffectiveStartDateUI)
                        : ''
                }
                withMask
                onDateChange={value => onChangBenefitEffectiveDate('enrollmentBenefitEffectiveStartDateUI', value)}
            />
            <ConditionalRendering isTrue={errors.enrollmentBenefitEffectiveStartDateUI}>
                <ErrorMessage
                    isVisible={errors.enrollmentBenefitEffectiveStartDateUI}
                    messageText={errors?.enrollmentBenefitEffectiveStartDateUI?.message}
                />
            </ConditionalRendering>
        </>
    );
};

export default EnrollmentStartDateField;
